import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Accordion } from 'carbon-react/lib/components/accordion';
import Typography from 'carbon-react/lib/components/typography';

import { SyncHistoryItem as SyncHistoryItemType } from '@futrli-sdk/organisations';

import { SyncHistoryItem } from './sync-history-item';

import * as styles from './sync-history.scss';

interface Props {
  history: SyncHistoryItemType[];
}

export const SyncHistory = ({ history }: Props) => (
  <section className={styles.container}>
    <hr className={styles.sectionDivider} />
    <div className={styles.accordion}>
      <Accordion
        defaultExpanded
        disableContentPadding
        borders="none"
        title={
          <Typography color="var(--colors-action-major-500, #007E45)" fontSize="16px" fontWeight="500" mb={0}>
            <FormattedMessage id="predict.sync_history.title" defaultMessage="Sync history" />
          </Typography>
        }
      >
        <ul className={styles.list}>
          {history.map((entry, index) => (
            <SyncHistoryItem key={`${entry.timestamp}-${index}`} entry={entry} />
          ))}
        </ul>
      </Accordion>
    </div>
  </section>
);
